module.exports = __webpack_public_path__ + "img/Internet.8fc21b08.jpg";